import { render, staticRenderFns } from "./ResultStatistics.vue?vue&type=template&id=782be3c4&scoped=true&"
import script from "./ResultStatistics.vue?vue&type=script&lang=ts&"
export * from "./ResultStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./ResultStatistics.vue?vue&type=style&index=0&id=782be3c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782be3c4",
  null
  
)

export default component.exports